import { shouldShowPinButton } from 'components/app/_helpers/_app.helper';
import { Clip } from 'components/app/editor/_mediator/editor.slice';
import { useClipsDelete } from 'components/app/editor/_mediator/editor-clips/use-clips-delete';
import { useHighlightPin } from 'components/app/selector/selector-clips/use-highlight-pin';

/**
 * Storyboard/editor remove: unpin pinned auto-highlights; no-op for unpinned highlights;
 * full-delete manual clips (#492).
 */
export const useRemoveOrUnpinClip = () => {
  const deleteClip = useClipsDelete();
  const { unpinHighlight } = useHighlightPin();

  return (clipId: ClipId, clipData?: Clip | null) => {
    if (clipData && shouldShowPinButton(clipData)) {
      // Unpinned highlights (e.g. Selector): no-op — avoid storyBoardDel error / wasted PATCH / undo junk
      if (clipData.isPinned ?? false) void unpinHighlight(clipData);
      return;
    }
    deleteClip(clipId);
  };
};
